import * as t from '../types';

export const setOrderTime = (restId, jour, hour) => async (
  dispatch,
  getState
) => {
  const restCartId = getState().cart.restId;
  if (restId === restCartId) {
    dispatch({ type: t.SET_ORDER_ID, payload: restId });
    dispatch({ type: t.SET_ORDER_JOUR, payload: jour });
    dispatch({ type: t.SET_ORDER_HOUR, payload: hour });
    // jour && dispatch({ type: t.SET_ORDER_JOUR, payload: jour });
    // hour && dispatch({ type: t.SET_ORDER_HOUR, payload: hour });
  } else {
    dispatch({ type: t.CLEAR_CART });
    dispatch({ type: t.SET_ORDER_ID, payload: restId });
    dispatch({ type: t.SET_ORDER_JOUR, payload: jour });
    dispatch({ type: t.SET_ORDER_HOUR, payload: hour });
    // jour && dispatch({ type: t.SET_ORDER_JOUR, payload: jour });
    // hour && dispatch({ type: t.SET_ORDER_HOUR, payload: hour });
  }
};
